import React, { createContext, ReactNode, useCallback, useState } from 'react';

interface NavigationContextProps {
  isNavigating: boolean;
  setIsNavigating: (isNavigating: boolean) => void;
}

const NavigationContext = createContext<NavigationContextProps>({
  isNavigating: true, // Start with loading on app boot
  setIsNavigating: () => {},
});

interface NavigationProviderProps {
  children: ReactNode;
}

const NavigationProvider: React.FC<NavigationProviderProps> = ({
  children,
}) => {
  const [isNavigating, setIsNavigating] = useState<boolean>(true); // Start loading

  const handleSetIsNavigating = useCallback((value: boolean) => {
    setIsNavigating(value);
  }, []);

  return (
    <NavigationContext.Provider
      value={{
        isNavigating,
        setIsNavigating: handleSetIsNavigating,
      }}
    >
      {children}
    </NavigationContext.Provider>
  );
};

export { NavigationContext, NavigationProvider };
